"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var $ = require("jquery");
var Cookie = /** @class */ (function () {
    function Cookie() {
        this.init();
    }
    Cookie.getInstance = function () {
        return new Cookie();
    };
    Cookie.prototype.init = function () {
        var _this = this;
        var $cookieBtn = $('.js-cookie');
        $cookieBtn.on('click', function (event) {
            event.preventDefault();
            var $cookies = $('.cookies');
            _this.createCookie('cwarning', 0, 30);
            $cookies.fadeOut(function () {
                $cookies.remove();
            });
        });
    };
    Cookie.prototype.createCookie = function (name, value, days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        var expires = "expires=" + date.toUTCString();
        document.cookie = name + "=" + value + ";" + expires + ";path=/";
    };
    return Cookie;
}());
exports.default = Cookie;
